export default __webpack_public_path__ + "static/media/image-2.fa058faf.png";